module.exports = __webpack_public_path__ + "static/media/starSelectedVector.8c2be50c.svg";